<div [ngClass]="loading ? 'lock' : ''">
  <div *ngIf="loading" class="table-loader-overlay" style="margin-top: 55px; ">
    <div style="margin-top: 145px; align-self: center">
      <mat-spinner
        style="margin:auto;"
        color="primary"
        diameter="75"
      ></mat-spinner>
    </div>
  </div>
  <table mat-table [dataSource]="subProjects">
    <ng-container matColumnDef="projectId">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>#</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        <span>{{ row.project.id }}</span>
        <span
          *ngIf="row.oldPlatformId != null"
          class="font-weight-bold font-italic"
        >
          ({{ row.project.oldPlatformId }})
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="currentCreatedAt">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Aanvraag</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        {{ row.createdAt | formatDate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Klantnaam</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        <ng-container *ngIf="row.project.companyNames?.length > 0">
          <div
            *ngFor="let companyName of row.project.companyNames"
            class="line-height center-row-content"
          >
            {{ companyName }}
          </div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="address">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Adres</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        {{
          row.projectPlacement?.address?.line1
            | printAddress
              : row.projectPlacement?.address?.postalCode
              : row.projectPlacement?.address?.city
        }}
      </td>
    </ng-container>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Project</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        <ng-container *ngIf="row.project.products?.length > 0">
          <div
            *ngFor="let product of row.project.products"
            class="line-height center-row-content"
            [matTooltip]="product.type"
          >
            {{ product.type | shortenText: 50 }}
          </div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Type</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        <ng-container *ngIf="row.project.products?.length > 0">
          <div
            *ngFor="let product of row.project.products"
            class="line-height center-row-content"
            [matTooltip]="product.displayType"
          >
            {{ product.displayType | shortenText: 50 }}
          </div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="measurements">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Afmetingen</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        <ng-container *ngIf="row.project.products?.length > 0">
          <div
            *ngFor="let product of row.project.products"
            class="line-height center-row-content"
          >
            {{ product.measurements }}
          </div>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="currentExecutionDate">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Uitgevoerd</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        {{ row.currentExecutionDate | formatDate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef class="header-text">
        <b>Status</b>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
        class="table-text"
        (click)="openProject(row)"
      >
        <span
          [ngClass]="
            row.type | overviewProjectTypeClass: row.status:row.withPlacement
          "
          class="status"
          (click)="navigateTab(row.id, row.project.id, row.displayStatus)"
        >
          {{ row.type | overviewProjectType: row.status:row.withPlacement }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr
      mat-row
      class="table-row"
      *matRowDef="let row; columns: displayedColumns"
      [ngClass]="row.statusClass"
    ></tr>
  </table>

  <div *ngIf="!subProjects || subProjects.length === 0" class="no-result-text">
    <div>Geen resultaten gevonden</div>
  </div>
  <mat-paginator
    [length]="totalItems"
    [pageSizeOptions]="pageSizeOptions"
    [showFirstLastButtons]="true"
    (page)="getSubProjectsSubject.next()"
  ></mat-paginator>
</div>
